(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Calendar.CalendarView",
                {
                    url: "/CalendarView",
                    component: "calendarView",
                    resolve: {
                    },
                    data: {
                        pageTitle: "Calendar View"
                    }
                });
        }
    ]);

    app.component("calendarView",
        {
            templateUrl: "/App/Calendar/CalendarView/calendarview-template.html",
            controller: calendarViewController,
            bindings: {
                allAppointments: "<",
                allScheduledTasks: "<",
                allMarketingTrackerEvents: "<",
                eventFilter: "<",
                ui: "<",
                onCalendarDateChange: "&"
            }
        });

    calendarViewController.$inject = ["$rootScope", "_", "$mdDialog", "uiCalendarConfig", "moment", "$q", "modalService", "$state", "badScheduledTasks"];
    function calendarViewController($rootScope, _, $mdDialog, uiCalendarConfig, moment, $q, modalService, $state, badScheduledTasks) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                calendar: {
                    height: "parent",
                    header: {
                        left: "month, agendaWeek, agendaDay, today",
                        center: "",
                        right: "prev, title, next"
                    },
                    defaultView: "month",
                    views: {
                        month: {
                            columnFormat: "dddd"
                        },
                        week: {
                            columnFormat: "ddd MMM D"
                        }
                    },
                    viewRender: function (view) {
                        var previousMonth = moment(new Date($ctrl.ui.year, $ctrl.ui.month, 1)).add(-1, "month");
                        var nextMonth = moment(new Date($ctrl.ui.year, $ctrl.ui.month, 1)).add(2, "month");
                        if (view.start._d < previousMonth || view.end._d > nextMonth) {
                            $ctrl.onCalendarDateChange({ start: view.start._d, end: view.end._d, today: view.calendar.getDate() });
                        }
                    },
                    eventClick: function (calEvent, jsEvent) {
                        if (calEvent.className[0] === "appointment-event")
                            $state.go("Home.Appointment", { appointmentId: calEvent.appointment.Id }, {});

                        if (calEvent.className[0] === "scheduled-task-event")
                            $state.go("Home.ScheduledTask", { taskId: calEvent.task.Id }, {});
                    },
                    // using dayClick instead of navLinks:true, because navLinks: true will not work with ui-calendar
                    // This will allow the user to select a day from the month/week view and take them to the day view
                    dayClick: function (date, jsEvent, view) {
                        if (view.name !== "month" && view.name !== "agendaWeek")
                            return;
                        uiCalendarConfig.calendars["calendar"].fullCalendar("changeView", "agendaDay");
                        uiCalendarConfig.calendars["calendar"].fullCalendar("gotoDate", date);
                    },
                    displayEventEnd: true,
                    // defaultDate - For some reasodn with the update to angular 1.6.10 the binding for $ctrl.ui fails to initialize before this does, so we're moving it to the onInit below - Harry
                    defaultDate: new Date(),

                },
                eventSource: {
                    events: []
                },
                modalService: modalService,
                filterByUser: filterByUser
            });

        function filterByUser() {

            $ctrl.filteredAppointments = _
                .chain($ctrl.allAppointments)
                .map("data")
                .flatten()
                .filter(event => {
                    return _.intersection(event.AssignedUserIds, _.map($ctrl.ui.selectedUsers, "Id")).length > 0 ? true : false;
                })
                .value();

            $ctrl.filteredScheduledTasks = _
                .chain($ctrl.allScheduledTasks)
                .map("data")
                .flatten()
                .filter(event => {
                    return _.includes(_.map($ctrl.ui.selectedUsers, "Id"), event.AssignedUserId);
                })
                .filter(event => {
                    // Hotfix: filter out bad scheduled tasks
                    return !_.includes(badScheduledTasks, event.Id);
                })
                .value();

            $ctrl.filteredMarketingTrackerEvents = _
                .chain($ctrl.allMarketingTrackerEvents)
                .map("data")
                .flatten()
                .filter(event => {
                    return _.includes(_.map($ctrl.ui.selectedUsers, "FigAuthId"), event.FigAuthId) || event.EventType.Name === "FIG Event";
                })
                .value();

            createCalendarEvents();
        }

        function createCalendarEvents() {
            $ctrl.eventSource = {
                events: []
            };

            if ($ctrl.eventFilter.showScheduledTasks)
                ng.forEach($ctrl.filteredScheduledTasks,
                    function (task) {
                        if ($ctrl.eventFilter.hideCompleted && task.CompletedDate) return;
                        const dueDate = moment(task.DueDate).format();
                        const allDay = moment(task.DueDate).hour(0).minute(0).second(0).format();
                        const isAllDay = dueDate === allDay ? true : false;
                        $ctrl.eventSource.events.push({
                            title: task.Name,
                            start: task.DueDate,
                            //TODO: move isAllDay & endTime to backend model
                            end: isAllDay ? null : moment(task.DueDate).add(30, 'minutes').format(),
                            allDay: isAllDay,
                            className: "scheduled-task-event",
                            color: task.Color,
                            textcolor: "#fff",
                            task: task
                        });
                    });

            if ($ctrl.eventFilter.showAppointments)
                ng.forEach($ctrl.filteredAppointments,
                    function (appointment) {
                        if ($ctrl.eventFilter.hideCompleted && appointment.IsCompleted) return;
                        const multiDay = !moment(appointment.StartDate).isSame(moment(appointment.EndDate), 'date'); // See if event spans multiple days
                        const offsetEndDate = multiDay ? moment(appointment.EndDate).add(1, 'days') : moment(appointment.EndDate); // offsetEndDate if multiday as per documentation

                        $ctrl.eventSource.events.push({
                            title: multiDay ? moment(appointment.StartDate).format("MM/DD") + " - " + moment(appointment.EndDate).format("MM/DD") + " " + appointment.Subject : appointment.Subject,
                            start: appointment.StartDate,
                            end: offsetEndDate.toDate(),
                            allDay: multiDay, // if its a multiday event, then make it all day too
                            className: "appointment-event",
                            color: appointment.Color,
                            textcolor: "#fff",
                            appointment: appointment
                        });
                    });

            if ($ctrl.eventFilter.showMarketingTrackerEvents)
                ng.forEach($ctrl.filteredMarketingTrackerEvents,
                    function (event) {
                        $ctrl.eventSource.events.push({
                            title: event.Title,
                            start: event.EventDate,
                            allDay: true,
                            className: "marketing-tracker-event",
                            marketingTrackerEvent: event
                        });
                    });

            updateCalendar();
        }

        function updateCalendar() {
            var calendar = ng.element(document.querySelector("#calendar"));
            if (calendar) {
                calendar.fullCalendar("removeEvents");
                calendar.fullCalendar("addEventSource", $ctrl.eventSource);
            }
        }

        $ctrl.$onChanges = function () {
            filterByUser();
        }

        $ctrl.$onInit = () => {
            $ctrl.calendar.defaultDate = (function (moment, year, month) {
                if (year !== moment().year() || month !== moment().month()) {
                    return moment(new Date(year, month, 1));
                } else {
                    return moment();
                }
            })(moment, $ctrl.ui.year, $ctrl.ui.month);
        }
    }

})(window.app, window.angular); //jshint ignore:line